module.exports = __webpack_public_path__ + "img/hair_front_female_bangs.8f1c4e00.png";